import React from 'react';

function BurnsTreatment() {
  return (
    <div>
      <h2>Burns Treatment</h2>
      <p>Here we provide professional burns treatment services...</p>
    </div>
  );
}

export default BurnsTreatment;
